import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  size = 'medium', 
  message = '', 
  overlay = false, 
  inline = false 
}) => {
  const sizeClass = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  }[size];

  const spinner = (
    <div className={`loading-spinner ${sizeClass} ${inline ? 'spinner-inline' : ''}`}>
    </div>
  );

  if (overlay) {
    return (
      <div className="loading-overlay" role="status" aria-live="polite">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;